module.exports = __webpack_public_path__ + "static/media/helper_icon.b24d0ec4.svg";